import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import {
    Box,
    Avatar,
    Grid,
    Card,
    CardActionArea,
    CardContent,
    CardHeader,
    Hidden,
  } from "@mui/material";
  import Typography from "@mui/material/Typography";

// estilos
import { styled } from "@mui/material/styles";

//iconos
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

const Div = styled("div")(({ theme }) => ({
    marginBottom: 15,
  }));
  
  const Alerta = styled(Alert)(({ theme }) => ({
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
      marginBottom: 15,
      color: "#799f4f",
    },
  }));
  
  const Div2 = styled("div")(({ theme }) => ({
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  }));
const Tarjetas = (props) => {
  // seteos
  //const dispatch = useDispatch();

  return (

            <>
            <Div>
              {/* Mostramos cuando la pantalla va de 1280px a 1920px o mas grabde */}
              <Hidden mdDown>
                <Grid container spacing={3}>
                {props.nro_expediente !== null ? (
                  <>
                    <Grid item xs={6} sm={3}>
                    <Card sx={{ padding: 1 }}>
                      <CardHeader
                        avatar={
                          <Avatar
                            aria-label="recipe"
                            sx={{ backgroundColor: "#799F4F" }}
                          >
                            <VpnKeyIcon />
                          </Avatar>
                        }
                        disabledTypography
                        title={
                          <Typography variant="titulo" component="p">
                            {props.nro_expediente}
                          </Typography>
                        }
                        subheader={
                          <Typography variant="cuerpo">Nº de expediente</Typography>
                        }
                        sx={{ height: "80px" }}
                      />
                    </Card>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <Card sx={{ padding: 1 }}>
                      <CardHeader
                        avatar={
                          <Avatar
                            aria-label="recipe"
                            sx={{ backgroundColor: "#799F4F" }}
                          >
                            <CalendarTodayIcon />
                          </Avatar>
                        }
                        disabledTypography
                        title={
                          <Typography variant="titulo" component="p">
                            {props.fecha_expediente}
                          </Typography>
                        }
                        subheader={
                          <Typography variant="cuerpo">
                            Inicio de expediente
                          </Typography>
                        }
                        sx={{ height: "80px" }}
                      />
                    </Card>
                  </Grid>
                  </>
                ):(null)}  
                
                  <Grid item xs={6} sm={3}>
                    <Card sx={{ padding: 1 }}>
                      <CardHeader
                        avatar={
                          <Avatar
                            aria-label="recipe"
                            sx={{ backgroundColor: "#799F4F" }}
                          >
                            <VpnKeyIcon />
                          </Avatar>
                        }
                        disabledTypography
                        title={
                          <Typography variant="titulo" component="p">
                            {props.nro_tramite}
                          </Typography>
                        }
                        subheader={
                          <Typography variant="cuerpo">
                            Nº de trámite interno
                          </Typography>
                        }
                        sx={{ height: "80px" }}
                      />
                    </Card>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <Card sx={{ padding: 1 }}>
                      <CardHeader
                        avatar={
                          <Avatar
                            aria-label="recipe"
                            sx={{ backgroundColor: "#799F4F" }}
                          >
                            <CalendarTodayIcon />
                          </Avatar>
                        }
                        disabledTypography
                        title={
                          <Typography variant="titulo" component="p">
                            {props.fecha_tramite}
                          </Typography>
                        }
                        subheader={
                          <Typography variant="cuerpo">Inicio de trámite</Typography>
                        }
                        sx={{ height: "80px" }}
                      />
                    </Card>
                  </Grid>
                  
                </Grid>
              </Hidden>
              {/* Mostramos cuando la pantalla va de 0px a 1280px */}
              <Hidden mdUp>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12}>
                    <Card sx={{ padding: 1 }}>
                      <CardHeader
                        avatar={
                          <Avatar
                            aria-label="recipe"
                            sx={{ backgroundColor: "#799F4F" }}
                          >
                            <VpnKeyIcon />
                          </Avatar>
                        }
                        disabledTypography
                        title={
                          <Typography variant="titulo" component="p">
                            {props.nro_tramite}
                          </Typography>
                        }
                        subheader={
                          <Typography variant="cuerpo">
                            Nº de trámite interno
                          </Typography>
                        }
                        sx={{ height: "80px" }}
                      />
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Card sx={{ padding: 1 }}>
                      <CardHeader
                        avatar={
                          <Avatar
                            aria-label="recipe"
                            sx={{ backgroundColor: "#799F4F" }}
                          >
                            <CalendarTodayIcon />
                          </Avatar>
                        }
                        disabledTypography
                        title={
                          <Typography variant="titulo" component="p">
                            {props.fecha_tramite}
                          </Typography>
                        }
                        subheader={
                          <Typography variant="cuerpo">Inicio de trámite</Typography>
                        }
                        sx={{ height: "80px" }}
                      />
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Card sx={{ padding: 1 }}>
                      <CardHeader
                        avatar={
                          <Avatar
                            aria-label="recipe"
                            sx={{ backgroundColor: "#799F4F" }}
                          >
                            <VpnKeyIcon />
                          </Avatar>
                        }
                        disabledTypography
                        title={
                          <Typography variant="titulo" component="p">
                            {props.nro_expediente}
                          </Typography>
                        }
                        subheader={
                          <Typography variant="cuerpo">Nº de expediente</Typography>
                        }
                        sx={{ height: "80px" }}
                      />
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Card sx={{ padding: 1 }}>
                      <CardHeader
                        avatar={
                          <Avatar
                            aria-label="recipe"
                            sx={{ backgroundColor: "#799F4F" }}
                          >
                            <CalendarTodayIcon />
                          </Avatar>
                        }
                        disabledTypography
                        title={
                          <Typography variant="titulo" component="p">
                            {props.fecha_expediente}
                          </Typography>
                        }
                        subheader={
                          <Typography variant="cuerpo">
                            Inicio de expediente
                          </Typography>
                        }
                        sx={{ height: "80px" }}
                      />
                    </Card>
                  </Grid>
                </Grid>
              </Hidden>
            </Div>
            </>
  );
};

export default Tarjetas;